module.exports = __webpack_public_path__ + "static/media/slider_turbo-szczotka.0ac3916b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider_turbo-szczotka.jpg
// module id = 832
// module chunks = 0